export default "__VITE_ASSET__Dy5KnmUk__"